//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const typicallyTriggers = useStore((state) => state.typicallyTriggers);
  const setTypicallyTriggers = useStore((state) => state.setTypicallyTriggers);
  const [next, setNext] = useState(typicallyTriggers.length > 0);

  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setTypicallyTriggers(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.typicallyTriggers.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={typicallyTriggers} onChange={handleChange}>
          <MultiOption value={'Having food nearby'}>
            <span>🥪</span> {t('onboarding.typicallyTriggers.options.foodNearby')}
          </MultiOption>
          <MultiOption value={'Feeling bored'}>
            <span>🥱️</span> {t('onboarding.typicallyTriggers.options.bored')}
          </MultiOption>
          <MultiOption value={'Being hungry'}>
            <span>😋</span> {t('onboarding.typicallyTriggers.options.hungry')}
          </MultiOption>
          <MultiOption value={'Stress'}>
            <span>🤯</span> {t('onboarding.typicallyTriggers.options.stress')}
          </MultiOption>
          <MultiOption value={'Other people snacking'}>
            <span>👯</span> {t('onboarding.typicallyTriggers.options.peopleSnacking')}
          </MultiOption>
          <MultiOption value={'Something else'}>
            <span>🍪</span> {t('onboarding.typicallyTriggers.options.somethingElse')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.typicallyTriggers.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'typically-triggers',
              answer: typicallyTriggers.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
